import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Logo from "../asset/logo.png";
// import "../Header/header.css";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Link } from "react-router-dom";

const pages = [
  { button: "Home", path: "/" },
  { button: "Resource", path: "/resource" },
  { button: "Covid-19", path: "/covid" },
  { button: "Buildings", path: "/building" },
  // { button: "Notice", path: "/notice" },
  { button: "Contact Us", path: "/contactus" },
  { button: "About Us", path: "/aboutus" },
];
const settings = ["Profile", "Account", "Dashboard", "Logout"];

const ResponsiveAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      className="menu-width"
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        background: "black",
        height: "100vh",
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, true)}
    >
      <Grid
        Container
        sx={{
          background: "black",
          display: "flex",
          justifyContent: "space-between",
          // padding: "20px 0",
          margin: "20px",
        }}
      >
        <Grid item sm={6}>
          <img src={Logo} alt="nothing to show" className="logo" />
        </Grid>
        <Grid item sm={6} sx={{ display: "flex", justifyContent: "end" }}>
          <CloseIcon onClose={toggleDrawer} sx={{ color: "white" }} />
        </Grid>
      </Grid>
      <Grid
        sx={{
          background: "black",
        }}
      >
        {pages.map((page) => (
          <Link style={{ textDecoration: "none" }} to={page.path}>
            <Typography
              sx={{
                fontFamily: "Epilogue",
                textAlign: "center",
                padding: "10px",
                color: "white",
              }}
            >
              {page.button}
            </Typography>
          </Link>
        ))}
      </Grid>
    </Box>
  );
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Grid
          container
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid item md={2}>
            <Box>
              <img className="logo" src={Logo} alt="nothing to show" />
            </Box>
          </Grid>
          <Toolbar
            className="nav-txt1"
            style={{ justifyContent: "space-between", display: "flex" }}
            disableGutters
          >
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "flex", md: "none", justifyContent: "flex-end" },
              }}
            >
              <div>
                {["left"].map((anchor) => (
                  <React.Fragment key={anchor}>
                    {/* <div style={{ display: "flex", justifyContent: "end" }}> */}
                    <MenuIcon onClick={toggleDrawer(anchor, true)} />
                    {/* </div> */}
                    <Drawer
                      anchor={anchor}
                      open={state[anchor]}
                      onClose={toggleDrawer(anchor, true)}
                    >
                      {list(anchor)}
                    </Drawer>
                  </React.Fragment>
                ))}
              </div>

              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={
                  {
                    // display: { xs: 'block', md: 'none' },
                  }
                }
              >
                {pages.map((page) => (
                  <Link style={{ textDecoration: "none" }} to={page.path}>
                    <MenuItem key={page} onClick={handleCloseNavMenu}>
                      <Typography textAlign="center">{page.button}</Typography>
                    </MenuItem>
                  </Link>
                ))}
              </Menu>
            </Box>

            <Grid item md={12}>
              <Box
                className="navbar-hide"
                sx={{ flexGrow: 1, display: "flex", justifyContent: "end" }}
              >
                {pages.map((page) => (
                  <Link style={{ textDecoration: "none" }} to={page.path}>
                    <Button
                      className="nav-txt"
                      key={page}
                      onClick={handleCloseNavMenu}
                      sx={{ my: 2, color: "white", display: "block" }}
                    >
                      {page.button}
                    </Button>
                  </Link>
                ))}
              </Box>
            </Grid>
          </Toolbar>
        </Grid>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
